import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { defaultTheme } from '../theme';
export const ThemeProvider = ({ children, theme: overrideTheme = {}, }) => {
    const theme = useMemo(() => (Object.assign(Object.assign({}, defaultTheme), overrideTheme)), [overrideTheme]);
    return (_jsx(StyledThemeProvider, { theme: theme, children: typeof children === 'function' ? children({ theme }) : children }));
};
//# sourceMappingURL=ThemeProvider.js.map